import { Box, useTheme } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons"

import { StandardTextBoxProps } from "./StandardTextBox.interfaces"

export const StandardTextBox = ({ text, bgcolor, color, icon, marginTop = 2, marginBottom = 2, fontSize = 16 }: StandardTextBoxProps) => {
  const theme = useTheme()
  const marginTopUnits = theme.spacing(marginTop)
  const marginBottomUnits = theme.spacing(marginBottom)
  const backgroundColor = bgcolor ?? theme.palette.primary.light
  const textColor = color ?? theme.palette.primary.dark
  const iconTexture = icon ?? faInfoCircle

  return (
    <Box
      marginTop={marginTopUnits}
      marginBottom={marginBottomUnits}
      display="flex"
      justifyContent="flex-start"
      flexDirection="column"
      bgcolor={backgroundColor}
      borderRadius="8px"
      color={textColor}
      p={2}
      gap={1}
    >
      <Box fontWeight="600" fontSize={fontSize}>
        <FontAwesomeIcon style={{ paddingRight: theme.spacing(0.25) }} icon={iconTexture} size="1x" />{" "}
        {text}
      </Box>
    </Box>
  )
}
